import { render, staticRenderFns } from "./AICredit.vue?vue&type=template&id=442d1023&"
import script from "./AICredit.vue?vue&type=script&lang=js&"
export * from "./AICredit.vue?vue&type=script&lang=js&"
import style0 from "./AICredit.vue?vue&type=style&index=0&id=442d1023&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports